export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  content: string[];
  category: string;
  categoryLabel: string;
  tags: string[];
  source: string;
  author: string;
  publishedAt: string;
  cover: string;
}

export const newsList: NewsItem[] = [
  {
    id: "blade-echo-season2",
    title: "《剑鸣回响》第二季正式定档，全新视觉图公开",
    summary:
      "官方正式公布第二季将于冬季开播，同步释出全新主视觉图与首支预告片，凛的全新姿态引发粉丝热议。",
    content: [
      "备受期待的《剑鸣回响》第二季终于有了确切消息。制作方白露动画工房在今日的线上发布会中宣布，第二季将于今年冬季正式开播。",
      "同步公开的主视觉图中，主角凛换上全新的黑色武者装束，缠绕裂纹状光纹的长剑直指天际。制作人透露，第二季将承接第一季结尾的悬念，正式揭开「鸣剑」的来历。",
      "首支预告片展示了约四十秒的正片画面，战斗分镜的密度与流畅度相较第一季有明显提升。配乐方面，第二季将继续由原班人马操刀，并邀请知名和乐器演奏家参与录制。",
      "此外，官方还宣布将推出角色设定集与限定周边，具体发售信息将在开播前一周公布。"],
    category: "news",
    categoryLabel: "新闻",
    tags: ["剑鸣回响", "新番", "定档"],
    source: "h动漫编辑部",
    author: "林一鸣",
    publishedAt: "2026-10-15",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20news%20illustration%20of%20a%20young%20swordsman%20holding%20glowing%20blade%20announcing%20season%20two%2C%20warm%20orange%20dramatic%20lighting%2C%20cel%20shaded%20promotional%20art%2C%20simple%20clean%20background&width=800&height=500&seq=news-cover-blade-echo-season2&orientation=landscape",
  },
  {
    id: "star-voyage-worldview-review",
    title: "深度解析：《星海彼端》世界观构建的三大妙笔",
    summary:
      "从舰船生态到社会结构，《星海彼端》用严谨的设定撑起了一个可信的宇宙。本文带你拆解它最精彩的三处设计。",
    content: [
      "《星海彼端》之所以能在众多科幻番中脱颖而出，靠的不只是精美的星空画面，更是一套自洽而细致的世界观。",
      "第一处妙笔是「方舟生态」。作品没有简单地把飞船当作交通工具，而是把它设计成一个闭环的小社会：空气、水、食物乃至情绪，都需要通过系统循环维持。这让「生存」这一主题有了具体的重量。",
      "第二处妙笔是「记忆档案」制度。每个船员都必须在登舰时上传一段最重要的记忆，以换取登舰资格。这个设定看似残酷，却为人物的每一次抉择都埋下了情感钩子。",
      "第三处妙笔则是「彼端」本身的模糊性。作品始终没有说明目标行星是否宜居，让整部番的悬念从第一集一直悬到最后一集，也让「希望」这个主题变得暧昧而真实。",
      "综上，《星海彼端》的设定并非堆砌，而是与人物命运深度绑定，这正是它令人信服的关键。"],
    category: "review",
    categoryLabel: "评论",
    tags: ["星海彼端", "世界观", "深度解析"],
    source: "h动漫专栏",
    author: "苏晴",
    publishedAt: "2026-10-14",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20editorial%20illustration%20of%20a%20spaceship%20interior%20with%20crew%20and%20starlit%20window%2C%20warm%20amber%20interior%20light%20against%20deep%20space%2C%20cel%20shaded%20art%2C%20clean%20background&width=800&height=500&seq=news-cover-star-voyage-review&orientation=landscape",
  },
  {
    id: "cherry-blossom-movie-trailer",
    title: "《樱花时雨》剧场版预告释出，青春群像再启程",
    summary:
      "时隔两年，咲与悠的故事将以剧场版形式回归。首支预告配合主题曲片段，把无数观众拉回了那个春天。",
    content: [
      "经典青春恋爱番《樱花时雨》正式宣布推出剧场版，并公开了首支预告片。",
      "预告以一段熟悉的钢琴旋律开场，画面从当年春天的那条樱花道缓缓拉开。虽然只是短短一分钟，却已经让不少老观众红了眼眶。",
      "官方透露，剧场版将讲述原电视动画结局之后的故事，聚焦咲与悠进入大学后所面临的新的离别与选择。监督在采访中表示：「这次我们想聊的，是喜欢一个人之后，如何继续长大。」",
      "剧场版预计于明年春季上映，主题曲由原班歌唱担当演唱。"],
    category: "preview",
    categoryLabel: "预告",
    tags: ["樱花时雨", "剧场版", "预告"],
    source: "h动漫编辑部",
    author: "周晓",
    publishedAt: "2026-10-13",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20promotional%20illustration%20of%20high%20school%20students%20under%20cherry%20blossoms%20for%20a%20movie%2C%20soft%20pink%20petals%20and%20warm%20spring%20light%2C%20cel%20shaded%20art%2C%20clean%20background&width=800&height=500&seq=news-cover-cherry-movie&orientation=landscape",
  },
  {
    id: "painted-sky-top-chart",
    title: "国产动画《绘空之城》登顶周榜，水墨美学引热议",
    summary:
      "凭借独特的水墨风格与扎实的叙事，《绘空之城》本周登顶播放榜，关于「国风动画新表达」的讨论再度升温。",
    content: [
      "本周播放数据出炉，国产原创动画《绘空之城》以微弱优势登顶周榜，成为本季度表现最亮眼的作品之一。",
      "《绘空之城》最受关注的是它的视觉风格。制作团队将传统水墨的留白与晕染融入 Cel 动画的流程中，让每个场景都像一幅流动的画卷。",
      "而在叙事层面，作品也摆脱了单纯炫技的窠臼，用「修补城市」的隐喻探讨家庭与失去，情感落点扎实。",
      "社交平台上，关于「国风动画该如何走出自己的路」的讨论随之升温，不少从业者也参与了这场公开的对话。"],
    category: "news",
    categoryLabel: "新闻",
    tags: ["绘空之城", "国产动画", "水墨"],
    source: "h动漫编辑部",
    author: "陈墨",
    publishedAt: "2026-10-13",
    cover:
      "https://readdy.ai/api/search-image?query=chinese%20ink%20painting%20style%20anime%20scene%20of%20a%20floating%20city%20in%20clouds%2C%20warm%20orange%20accent%20light%2C%20watercolor%20cel%20shaded%20background%2C%20elegant%20negative%20space&width=800&height=500&seq=news-cover-painted-sky-chart&orientation=landscape",
  },
  {
    id: "paper-crane-review",
    title: "评《千纸之愿》：温柔叙事下的生命哲思",
    summary:
      "它没有宏大的场面，却用一千只纸鹤撑起了一个关于告别的故事。这或许是最不「用力」的一部催泪番。",
    content: [
      "在追求爽感与刺激的当下，《千纸之愿》显得格外安静。它把几乎所有的镜头都留给了医院走廊、窗台与午后阳光。",
      "但正是这种克制，成就了它独特的感染力。作品从不刻意提醒你「这里该哭了」，而是让情绪在一次次日常的重复中自然累积。",
      "折纸鹤这一反复出现的动作，是整部作品最精妙的设计。它既是少女对抗命运的方式，也是两人之间无声的约定，更在结局时化作了对观众的温柔告别。",
      "如果说许多催泪番是用刀锋划过心脏，那《千纸之愿》更像是一只温暖的手，轻轻地按在伤口上。它让人流泪，却不让人绝望。"],
    category: "review",
    categoryLabel: "评论",
    tags: ["千纸之愿", "治愈", "剧评"],
    source: "h动漫专栏",
    author: "苏晴",
    publishedAt: "2026-10-12",
    cover:
      "https://readdy.ai/api/search-image?query=gentle%20anime%20hospital%20window%20scene%20with%20origami%20cranes%20and%20warm%20sunlight%2C%20soft%20cream%20tones%2C%20cel%20shaded%20healing%20mood%2C%20clean%20simple%20background&width=800&height=500&seq=news-cover-paper-crane-review&orientation=landscape",
  },
  {
    id: "spirit-eater-main-arc",
    title: "《灵食猎人》新章预告：主线迎来最大转折",
    summary:
      "官方释出新章预告，主角燎的身世之谜即将揭开，剧情将从单元剧转向更大的格局，粉丝直呼「终于等到了」。",
    content: [
      "长期以单元剧形式推进的《灵食猎人》，终于要迎来主线的爆发。",
      "最新发布的预告片中，燎在净化一只强大魔物时，意外看到了与自己童年相关的画面。短短十几秒的镜头，却暗示了此前所有伏笔的收束。",
      "制作组表示，接下来的「身世篇」将是全作的分水岭，单元剧的轻松氛围会逐步让位于更沉重的主线。",
      "对于追了数十集的观众来说，这无疑是期待已久的时刻。"],
    category: "preview",
    categoryLabel: "预告",
    tags: ["灵食猎人", "主线", "预告"],
    source: "h动漫编辑部",
    author: "周晓",
    publishedAt: "2026-10-11",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20promotional%20art%20of%20a%20hunter%20facing%20a%20mysterious%20glowing%20spirit%20creature%2C%20warm%20orange%20flame%20light%2C%20cel%20shaded%20dramatic%20art%2C%20clean%20background&width=800&height=500&seq=news-cover-spirit-eater-preview&orientation=landscape",
  },
  {
    id: "moonlit-lane-finale",
    title: "《月巷迷踪》完结篇上线，开放式结局引爆讨论",
    summary:
      "完结篇上线后，那个悬而未决的真相成为全网热议的话题。有人拍手叫绝，也有人意难平。",
    content: [
      "《月巷迷踪》的完结篇已在各大平台上线，而这个坚持了二十集的谜题，最终给出了一个耐人寻味的开放式结局。",
      "结局中，主角辰终于找到了月巷尽头的真相，却发现所谓的「真相」本身也是可以被操纵的。最后一幕，他站在空无一人的老巷里，选择把手中的证据付之一炬。",
      "这一处理在观众中引发了巨大的分歧：有人认为这是神来之笔，留白恰到好处；也有人认为这是「挖坑不填」。",
      "无论如何，这场讨论本身就证明了作品的成功——它让观众在剧终之后，依然愿意继续思考。"],
    category: "news",
    categoryLabel: "新闻",
    tags: ["月巷迷踪", "完结", "讨论"],
    source: "h动漫编辑部",
    author: "陈墨",
    publishedAt: "2026-08-21",
    cover:
      "https://readdy.ai/api/search-image?query=atmospheric%20anime%20night%20alley%20scene%20with%20lanterns%20and%20mist%20for%20a%20finale%2C%20warm%20amber%20lantern%20glow%2C%20painterly%20cel%20shaded%20background&width=800&height=500&seq=news-cover-moonlit-finale&orientation=landscape",
  },
  {
    id: "mecha-dawn-ten-years",
    title: "《机甲黎明》十周年：一部机战番的时代印记",
    summary:
      "十年过去，「黎明」依旧是无数观众心中的白月光。回望这部作品，我们谈的不只是机甲。",
    content: [
      "十年前，《机甲黎明》首播。十年后，它依然是机战爱好者绕不开的话题。",
      "作品最动人的地方，从来不是华丽的机体，而是那些坐在驾驶舱里的少年。他们被时代推上战场，却始终在追问「为什么战斗」。",
      "在当年的动画语境下，这种对战争的反思显得尤为难得。它没有歌颂胜利，而是诚实地呈现了胜利的代价。",
      "十周年纪念活动上，原声优们重聚，为观众朗读了当年的名台词。当那句「黎明之前，总要有人先睁开眼」再次响起时，弹幕瞬间被「爷青回」刷屏。"],
    category: "review",
    categoryLabel: "评论",
    tags: ["机甲黎明", "十周年", "怀旧"],
    source: "h动漫专栏",
    author: "林一鸣",
    publishedAt: "2026-04-23",
    cover:
      "https://readdy.ai/api/search-image?query=retro%20anime%20mecha%20scene%20at%20dawn%20with%20giant%20robot%20silhouette%2C%20warm%20orange%20sunrise%20tones%2C%20cinematic%20cel%20shaded%20background%2C%20nostalgic%20mood&width=800&height=500&seq=news-cover-mecha-anniversary&orientation=landscape",
  },
  {
    id: "dragon-chef-spring",
    title: "《龙厨奇谭》定档春季，美食番再添新作",
    summary:
      "一个少年、一条龙、一辆餐车，这场环球美食冒险即将开播。官方同步公开了主要角色设定。",
    content: [
      "美食冒险番《龙厨奇谭》正式定档，将于春季开播。",
      "官方公开的主要角色设定中，主角小饱是一名热情过头的少年厨师，而他的搭档是一条名为「咕噜」、只会吃的小龙。这个组合的喜剧效果从设定阶段就已经拉满。",
      "制作团队表示，本作将采用单元剧结构，每一集都会聚焦一地美食与一位食客的故事，力求做到「又馋又暖」。",
      "对于喜欢轻松下饭番的观众来说，这无疑是春季档的一大期待。"],
    category: "preview",
    categoryLabel: "预告",
    tags: ["龙厨奇谭", "美食番", "定档"],
    source: "h动漫编辑部",
    author: "周晓",
    publishedAt: "2026-10-11",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20anime%20promotional%20art%20of%20a%20young%20chef%20and%20cute%20dragon%20with%20colorful%20food%2C%20warm%20orange%20kitchen%20light%2C%20cel%20shaded%20art%2C%20clean%20simple%20background&width=800&height=500&seq=news-cover-dragon-chef-spring&orientation=landscape",
  },
  {
    id: "echo-garden-cast",
    title: "声优阵容公布！《回声花园》音乐番的幕后故事",
    summary:
      "为了还原真实的演奏效果，制作组请来专业乐手参与录制，声优们也接受了长达半年的乐器特训。",
    content: [
      "音乐番最难的地方，在于如何让「演奏」看起来、听起来都足够真实。《回声花园》制作组为此下足了功夫。",
      "据制作人介绍，为了还原合奏的质感，团队邀请专业乐手录制了完整的演奏音轨，而声优们则在开播前接受了长达半年的乐器特训，只为让指法与神态更可信。",
      "此外，作品中的每一首原创曲目都经过了反复打磨，力求既有青春感，又能经得起反复聆听。",
      "「我们希望大家听到的不只是背景音乐，而是角色真正想说却说不出口的话。」监督在采访中这样说道。"],
    category: "news",
    categoryLabel: "新闻",
    tags: ["回声花园", "音乐", "幕后"],
    source: "h动漫编辑部",
    author: "苏晴",
    publishedAt: "2026-07-28",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20scene%20of%20a%20school%20music%20room%20with%20violin%20and%20students%20rehearsing%2C%20warm%20orange%20golden%20hour%20light%2C%20cel%20shaded%20background%2C%20clean%20simple&width=800&height=500&seq=news-cover-echo-garden-cast&orientation=landscape",
  },
];